export default __webpack_public_path__ + "static/media/NIAS0360.34I-32925_-17932_0.bcd1e67b.jpg";